import styled from 'styled-components';
import Variables from '../../assets/styleVariables';

export const LogoContainer = styled.div`
  .logo-mapsa-container {
    max-width: 150px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .logo {
      img {
        width: 30px;
        height: 28px;
      }
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .title {
      margin-right: 12px;
      div:first-child {
        font-size: ${Variables.font_sizes.large};
        color: ${Variables.colors.complementary_900};
        font-weight: ${Variables.font_weight.medium};
        letter-spacing: -0.45px;
      }
      div:last-child {
        font-size: ${Variables.font_sizes.x_small};
        color: ${Variables.colors.complementary_700};
        letter-spacing: -0.3px;
      }
    }
  }
`;